import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_USER_ROUND_CHECK: GlameraIconDefinition = {
  name: 'user-round-check',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-user-round-check-body" d="M2 21a8 8 0 0 1 13.292-6"></path>
    <circle class="glm-user-round-check-head" cx="10" cy="8" r="5"></circle>
    <path class="glm-user-round-check-tick" d="m16 19 2 2 4-4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-user-round-check-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './user-round-check.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserRoundCheckIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_USER_ROUND_CHECK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
